import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { startWith, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScreenService implements OnDestroy {
  // Mínimo de píxeles para detectar el cambio
  private readonly MOBILE_BREAKPOINT: number = 1040

  // Guarda la subscripción al resize para poder cancelarla
  private resizeSub: Subscription

  // BehaviorSubject: mantiene el estado actual de si es móvil o no y emite inmediatamente al suscribirse
  private mobileSubject = new BehaviorSubject<boolean>(this.checkIfScreenIsMobile())

  // Observable público: solo lectura, evita que otros hagan .next() directamente
  public isMobile$ = this.mobileSubject.asObservable()

  constructor() {
    this.resizeSub = fromEvent(window, 'resize')  // Convierte un evento del DOM en un Observable
      .pipe(
        debounceTime(150),  // Espera 150ms sin eventos antes de emitir para no saturar
        map(() => this.checkIfScreenIsMobile()),  // Mapea el evento a un boolean indicando si es móvil
        distinctUntilChanged(), // Solo emite cuando el valor cambia (evita emisiones repetidas)
        startWith(this.checkIfScreenIsMobile()) // Emite inmediatamente el valor inicial al suscribirse
      ).subscribe(this.mobileSubject) // Emite inmediatamente el valor inicial al suscribirse (Está haciendo el .next() internamente)
  }

  ngOnDestroy(): void {
    this.resizeSub.unsubscribe()  // Evita memory leaks al destruir el servicio
  }

  private checkIfScreenIsMobile(): boolean {
    return window.innerWidth <= this.MOBILE_BREAKPOINT  // Devuelve true si la pantalla es igual o menor al breakpoint
  }
}
